import { faBox, faEye, faBoxesPacking, faBoxesStacked, faEdit, faImage, faFilePdf, faPencilAlt, faCheck, faTimes } from "@fortawesome/free-solid-svg-icons";
import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { X, Eye ,ChevronDown} from "lucide-react";
// import { Msg200or201, Msg204, Msg400, Msg401, Msg409, Msg403, Msg500 } from '../../Messages/Messages';
import { useNavigate } from "react-router-dom";
import { decryptData } from "../../../utils/storageCrypto";

/* ================= STEP UI HELPER ================= */
const RenderDeliveryGroupMapping = ({activeStep, deliveryGroup, handleGetDg,setShowPopup,
  setPopupType,
  setPopupMessage}) => {
  const navigate = useNavigate()
  // STEP 1: RFQ PLACED
  const [showSlotPopup, setShowSlotPopup] = useState(false);
  const [slotDate, setSlotDate] = useState("");
  const [slotTime, setSlotTime] = useState(""); 
  const [shiftPopupVisible, setShiftPopupVisible] = useState(false);
  const [shiftToValue, setShiftToValue] = useState("");
  const API_BASE = process.env.REACT_APP_FORE_BRICKBUCKET + 'customer/salesorder';
  const imageurl = process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES;
  const [billPopup, setBillPopup] = useState(false);
  const [billData, setBillData] = useState(null);
  const [editBill, setEditBill] = useState(false);
  const [billNumber, setBillNumber] = useState("");
  // const [showPopup, setShowPopup] = useState(false);
  // const [popupType, setPopupType] = useState("");
  // const [popupMessage, setPopupMessage] = useState("");
  const [showPreview, setShowPreview] = useState(false);
  const [subOrderData, setSubOrderData] = useState(null);
  const [showRejectReason, setShowRejectReason] = useState(false);
const [rejectReason, setRejectReason] = useState("");
const [expandedPO, setExpandedPO] = useState(null);

   const saveSlotUpdate = async () => {
    try {
        if (!deliveryGroup._id) return;

        const delivery_grouping_id =  deliveryGroup._id || "";

        const payload = {
        delivery_grouping_id,
        delivery_date: slotDate || undefined,
        delivery_slot: slotTime || undefined
        };
        const encryptedToken = sessionStorage.getItem('token');
                const token = decryptData(encryptedToken);

        console.log('token', token)
        const response = await fetch(`${API_BASE}/update-delivery-grouping`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            'x-token': token
        },
        body: JSON.stringify(payload)
        });

        const result = await response.json(); // ⬅⬅⬅ FIXED

        if (result.success) {
        const updated = result.data  
        setShowSlotPopup(false);
        setSlotDate('');
        setSlotTime('');
        handleGetDg()
        } else {
        console.error('Failed to update slot', result); // ⬅ Now prints correct error
        setShowSlotPopup(false);
        }

    } catch (err) {
        console.error('Error saving slot update', err);
        setShowSlotPopup(false);
    }
  };



const handleAcceptBill = async () => {
  try {
    const encryptedToken = sessionStorage.getItem('token');
    const token = decryptData(encryptedToken);

    const response = await fetch(
      `${process.env.REACT_APP_FORE_BRICKBUCKET}bill/accept-supplier-bill`, // ✅ Correct endpoint
      {
        method: "POST", // ✅ Changed from PUT to POST
        headers: {
          "Content-Type": "application/json",
          "x-token": token
        },
        body: JSON.stringify({
          bill_id: billData._id  // ✅ Changed from billId to bill_id
        })
      }
    );

    const result = await response.json();
    console.log("Accept Bill Response:", result);

    if (result.success) {
      setPopupType('200or201');
      setPopupMessage("Bill accepted successfully!");
      setShowPopup(true);
       setBillPopup(false);
      handleGetDg(); 
      setTimeout(() => {
        setShowPopup(false);
      }, 2000);
 await handleViewBill({ purchaseorder_id: billData.purchaseorder_id });

    } else {
      setPopupType('400');
      setPopupMessage(result.message || "Failed to accept bill");
      setShowPopup(true);
    }
  } catch (err) {
    console.error("Accept bill error:", err);
    setPopupType('500');
    setPopupMessage("Something went wrong!");
    setShowPopup(true);
  }
};

const handleRejectBill = async (reason = "") => {
  try {
    const encryptedToken = sessionStorage.getItem('token');
    const token = decryptData(encryptedToken);

    const response = await fetch(
      `${process.env.REACT_APP_FORE_BRICKBUCKET}bill/reject-supplier-bill`, // ✅ Correct endpoint
      {
        method: "POST", // ✅ Changed from PUT to POST
        headers: {
          "Content-Type": "application/json",
          "x-token": token
        },
        body: JSON.stringify({
          bill_id: billData._id , // ✅ Changed from billId to bill_id
         reject_reason: reason || rejectReason 
        })
      }
    );
    console.log("body sent for rejection:", {
      bill_id: billData._id,
      reject_reason: reason || rejectReason
    });

    const result = await response.json();
    console.log("Reject Bill Response:", result);

    if (result.success) {
      setPopupType('200or201');
      setPopupMessage("Bill rejected successfully!");
       setShowPopup(true);
      setBillPopup(false);
      handleGetDg(); 
      setTimeout(() => {
        setShowPopup(false);
      }, 2000);

    await handleViewBill({ purchaseorder_id: billData.purchaseorder_id });

    } else {
      setPopupType('400');
      setPopupMessage(result.message || "Failed to reject bill");
      setShowPopup(true);
    }
  } catch (err) {
    console.error("Reject bill error:", err);
    setPopupType('500');
    setPopupMessage("Something went wrong!");
    setShowPopup(true);
  }
};

const openSlotPopup = () => {

  setSlotDate(
    deliveryGroup?.delivery_date
      ? deliveryGroup.delivery_date.split("T")[0]
      : ""
  );

  setSlotTime(deliveryGroup?.delivery_slot || "");

  setShowSlotPopup(true);
};

// CLOSE SLOT POPUP
const closeSlotPopup = () => {
  setShowSlotPopup(false);
  setSlotDate("");
  setSlotTime("");
  
};

const updateShiftAPI = async (groupId, shiftValue) => {
  const encryptedToken = sessionStorage.getItem('token');
  const token = decryptData(encryptedToken);

  try {
    const response = await fetch(`${API_BASE}/update-delivery-grouping`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" ,
         'x-token': token
      },
      body: JSON.stringify({
        delivery_grouping_id: groupId,
        is_delivered_by_brickbucket: shiftValue === "Brickbucket"
      })
    });

    const data = await response.json();
    console.log("Shift update response:", data); 
    return data;
    
  } catch (error) {
    console.log("Shift update error:", error);
    return { success: false };
  }
};



const saveShiftChange = async () => {
  
  const res = await updateShiftAPI(deliveryGroup._id, shiftToValue);

  if (res.success) {
   handleGetDg()
  }

  setShiftPopupVisible(false);
};


const handleViewBill = async (subOrder) => {
  try {
    const poId = subOrder?.purchaseorder_id?._id || subOrder?.purchaseorder_id;
    console.log(poId)
    const encryptedToken = sessionStorage.getItem('token');
    const token = decryptData(encryptedToken);
    const response = await fetch(
      `${process.env.REACT_APP_FORE_BRICKBUCKET}bill/get-bill-by-suborder-number?po_id=${poId}`,{
      method: "GET",
      headers: { "Content-Type": "application/json" ,
      'x-token': token
      },
      }
    );
    

    const data = await response.json();
    console.log("Fetch Bill Response:", data);

    if (data.success) {
      setBillData(data.data);              
      setBillNumber(data.data.bill_number) 
      
      if (data.data.reject_reason) {
        setRejectReason(data.data.reject_reason);
         setShowRejectReason(true);
      } else {
        setRejectReason("");
        setShowRejectReason(false);
      }
      
      setEditBill(false);   
      setBillPopup(true);                
    } else {
      setPopupType('400');
      setPopupMessage("Bill not found");
      setShowPopup(true);
    }
  } catch (error) {
    console.error("Error fetching bill:", error);
    setPopupType('500');
    setPopupMessage("Something went wrong!");
    setShowPopup(true);
  }
};

const truncateFileName = (name, maxLen = 30) => {
  if (!name) return "";
  if (name.length <= maxLen) return name;
  const dotIdx = name.lastIndexOf(".");
  const ext = dotIdx !== -1 ? name.slice(dotIdx) : "";
  const base = dotIdx !== -1 ? name.slice(0, dotIdx) : name;
  const visible = Math.max(6, Math.floor((maxLen - ext.length - 3) / 2));
  return `${base.slice(0, visible)}...${base.slice(-visible)}${ext}`;
};

const updateBillNumber = async () => {
  const encryptedToken = sessionStorage.getItem('token');
  const token = decryptData(encryptedToken);

  try {
    const response = await fetch(
      `${process.env.REACT_APP_FORE_BRICKBUCKET}bill/update-bill`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          "x-token": token
        },
        body: JSON.stringify({
          billId: billData._id,
          updateData: { 
            bill_number: billNumber,
            reject_reason: rejectReason || undefined  // ✅ ONLY THIS LINE
          }
        })
      }
    );

    const result = await response.json();

    if (result.success) {
      setPopupType('200or201');
      setPopupMessage("Bill updated successfully!");
      setBillPopup(false);
      setShowPopup(true);
      setTimeout(() => setShowPopup(false), 3000);
    } else {
      setPopupType('400');
      setPopupMessage(result.message);
      setShowPopup(true);
    }
  } catch (err) {
    console.error("Update bill error:", err);
    setPopupType('500');
    setPopupMessage("Something went wrong!");
    setShowPopup(true);
  }
};


const handleViewInvoice = async (subOrder) => {
  try {
    const poId = subOrder?.purchaseorder_id;
    console.log("View Invoice Clicked For PO ID:", poId);

    if (!poId) {
      console.error("No Purchase Order ID found!");
      setPopupType('400');
      setPopupMessage("No Purchase Order ID found!");
      setShowPopup(true);
      return;
    }

    const encryptedToken = sessionStorage.getItem('token');
                const token = decryptData(encryptedToken);

    // Fetch invoice
    const response = await fetch(
      `${process.env.REACT_APP_FORE_BRICKBUCKET}invoice/get-invoice-by-poid?po_id=${poId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "x-token": token,
        },
      }
    );

    const data = await response.json();
    console.log("View Invoice API Response:", data);

    if (data.success && data.data) {
      const invoice = data.data;

     if (!invoice.files || invoice.files.length === 0) {
        setPopupType('400');
        setPopupMessage("No files found in invoice!");
        setShowPopup(true);
        return;
      }


      // Find FIRST PDF file
      const pdfFile = invoice.files.find(file =>
        file.toLowerCase().endsWith(".pdf")
      );
 if (!pdfFile) {
        setPopupType('400');
        setPopupMessage("No PDF file found in invoice!");
        setShowPopup(true);
        return;
      }

      // Build URL
      const pdfUrl = process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES + pdfFile;

      console.log("Opening PDF:", pdfUrl);

      // OPEN PDF IN NEW TAB 🚀
      window.open(pdfUrl, "_blank");

   } else {
      setPopupType('400');
      setPopupMessage(data.message || "Failed to fetch invoice");
      setShowPopup(true);
    }
  } catch (error) {
    console.error("View Invoice Error:", error);
    setPopupType('500');
    setPopupMessage("Something went wrong!");
    setShowPopup(true);
  }
};

 const closePopup = () => {
    setShowPopup(false);
  };
  
const Retry = () => {
  // Implement retry logic, e.g., refetch data
  setShowPopup(false);
};

const BackToLoginPage = () => {
    console.log("Back To Login Page");
    setShowPopup(false);
    localStorage.removeItem('LoginData');
    sessionStorage.removeItem('userData');
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('userId');
    sessionStorage.removeItem('appId');
  navigate('/bb');
  };

  if (!deliveryGroup) return null;

  return (
    <div className="bg-white rounded-md shadow p-4">

{/* =========================================================
    PROFESSIONAL DELIVERY GROUP + PURCHASE ORDERS CARD
========================================================= */}
<div className="bg-white border border-gray-200 rounded-xl shadow-sm overflow-hidden">

  {/* =======================================================
      TOP HEADER
  ======================================================== */}
  <div className="px-5 py-4 border-b border-gray-200 bg-white">

    <div className="flex items-center justify-between gap-4">

      <div className="flex items-center gap-3 min-w-0">

        <div className="w-9 h-9 rounded-lg bg-blue-50 border border-blue-100 flex items-center justify-center flex-shrink-0">
          <FontAwesomeIcon
            icon={faBox}
            className="text-blue-600 text-sm"
          />
        </div>

        <div className="min-w-0">

          <p className="text-[11px] font-semibold text-gray-400 uppercase tracking-wider">
            Delivery Group
          </p>

          <p className="text-sm font-bold text-gray-900 truncate mt-0.5">
            {deliveryGroup.delivery_group_number || "—"}
          </p>

        </div>

      </div>


      <div className="flex items-center gap-2 flex-shrink-0">

{/*         <span className="hidden sm:inline-flex px-2.5 py-1 rounded-full text-[10px] font-semibold bg-blue-50 text-blue-700 border border-blue-100">
          DELIVERY GROUP
        </span> */}

        <span className="inline-flex items-center px-2 py-1 rounded-full text-[10px] font-semibold bg-gray-100 text-gray-600">
          {deliveryGroup?.sub_orders?.length || 0} PO
        </span>

      </div>

    </div>

  </div>


  {/* =======================================================
      BODY
  ======================================================== */}
  <div className="grid grid-cols-1 lg:grid-cols-[310px_minmax(0,1fr)]">


    {/* =====================================================
        LEFT - DELIVERY GROUP DETAILS
    ====================================================== */}
    <div className="border-b lg:border-b-0 lg:border-r border-gray-200 bg-gray-50/70">

      <div className="p-5">

        {/* SECTION TITLE */}
{/*         <div className="flex items-center gap-2 mb-4">

          <div className="w-7 h-7 rounded-md bg-white border border-gray-200 flex items-center justify-center">
            <FontAwesomeIcon
              icon={faBox}
              className="text-gray-500 text-xs"
            />
          </div>

          <div>

            <p className="text-xs font-semibold text-gray-900">
              Delivery Details
            </p>

            <p className="text-[10px] text-gray-400">
              Delivery group information
            </p>

          </div>

        </div> */}


        {/* =================================================
            DELIVERY SLOT
        ================================================== */}
        <div className="bg-white border border-gray-200 rounded-lg p-3.5 mb-3">

          <div className="flex items-start justify-between gap-3">

            <div className="min-w-0">

              <p className="text-[10px] font-semibold text-gray-400 uppercase tracking-wider">
                Delivery Slot
              </p>

              <p className="text-sm font-semibold text-gray-900 mt-1">
                {deliveryGroup.delivery_date
                  ? new Date(
                      deliveryGroup.delivery_date
                    ).toLocaleDateString("en-IN", {
                      day: "numeric",
                      month: "short",
                      year: "numeric",
                    })
                  : "Not Scheduled"}
              </p>

              <p className="text-xs text-gray-500 mt-0.5">
                {deliveryGroup.delivery_slot || "No slot selected"}
              </p>

            </div>


            <button
              onClick={openSlotPopup}
              className="
                flex
                items-center
                gap-1
                px-2
                py-1
                rounded-md
                text-[11px]
                font-medium
                text-blue-600
                hover:bg-blue-50
                transition
                flex-shrink-0
              "
            >

              <FontAwesomeIcon
                icon={faEdit}
                className="text-[9px]"
              />

              Edit

            </button>

          </div>

        </div>


        {/* =================================================
            BILL TO
        ================================================== */}
        <div className="bg-white border border-gray-200 rounded-lg p-3.5 mb-3">

          <p className="text-[10px] font-semibold text-gray-400 uppercase tracking-wider">
            Bill To
          </p>

          <p className="text-sm font-semibold text-gray-900 mt-1">
            {deliveryGroup.bill_to || "Brick Bucket"}
          </p>

        </div>


        {/* =================================================
            SHIP TO
        ================================================== */}
        <div className="bg-white border border-gray-200 rounded-lg p-3.5 mb-3">

          <div className="flex items-center justify-between gap-3">

            <div className="min-w-0">

              <p className="text-[10px] font-semibold text-gray-400 uppercase tracking-wider">
                Ship To
              </p>

              <p className="text-sm font-semibold text-gray-900 mt-1">
                {deliveryGroup.is_delivered_by_brickbucket
                  ? "Brickbucket"
                  : "Customer"}
              </p>

            </div>


            <button
              className={`
                px-2.5
                py-1
                text-[11px]
                font-medium
                border
                rounded-md
                transition
                ${
                  activeStep === 1
                    ? "text-blue-600 border-blue-200 hover:bg-blue-50"
                    : "text-gray-400 border-gray-200 cursor-not-allowed bg-gray-50"
                }
              `}
              onClick={() => setShiftPopupVisible(true)}
              disabled={activeStep !== 1}
            >
              Edit
            </button>

          </div>

        </div>


        {/* =================================================
            SUMMARY
        ================================================== */}
{/*         <div className="bg-white border border-gray-200 rounded-lg overflow-hidden">

          <div className="px-3.5 py-3 border-b border-gray-100">

            <p className="text-[10px] font-semibold text-gray-400 uppercase tracking-wider">
              Summary
            </p>

          </div>


          <div className="divide-y divide-gray-100">

            <div className="px-3.5 py-2.5 flex items-center justify-between gap-3">

              <span className="text-xs text-gray-500">
                DG Number
              </span>

              <span className="text-xs font-semibold text-gray-900 text-right">
                {deliveryGroup.delivery_group_number || "—"}
              </span>

            </div>


            <div className="px-3.5 py-2.5 flex items-center justify-between gap-3">

              <span className="text-xs text-gray-500">
                Purchase Orders
              </span>

              <span className="text-xs font-semibold text-gray-900">
                {deliveryGroup?.sub_orders?.length || 0}
              </span>

            </div>


            <div className="px-3.5 py-2.5 flex items-center justify-between gap-3">

              <span className="text-xs text-gray-500">
                Delivery Mode
              </span>

              <span className="text-xs font-semibold text-gray-900 text-right">
                {deliveryGroup.is_delivered_by_brickbucket
                  ? "Brickbucket"
                  : "Customer"}
              </span>

            </div>

          </div>

        </div> */}

      </div>

    </div>


    {/* =====================================================
        RIGHT - PURCHASE ORDERS
    ====================================================== */}
    <div className="min-w-0 flex flex-col">

      {/* PO HEADER */}
      <div className="px-5 py-4 border-b border-gray-200">

{/*         <div className="flex items-center justify-between gap-3">

          <div>

            <p className="text-sm font-semibold text-gray-900">
              Purchase Orders
            </p>

            <p className="text-[11px] text-gray-400 mt-0.5">
              Orders associated with this delivery group
            </p>

          </div>

          <span className="text-xs font-medium text-gray-500">
            {deliveryGroup?.sub_orders?.length || 0} Orders
          </span>

        </div> */}

      </div>


      {/* =====================================================
          SCROLLABLE PO LIST
      ====================================================== */}
      <div
        className="
          max-h-[500px]
          overflow-y-auto
          custom-scrollbar
        "
      >

        {deliveryGroup?.sub_orders?.length > 0 ? (

          <div>

          {deliveryGroup.sub_orders.map((subOrder, index) => {

            const isExpanded = expandedPO === subOrder._id;

            return (
              <div
                key={subOrder._id}
                className={`
                  border-b
                  border-gray-300
                  last:border-b-0
                  ${index % 2 === 0 ? "bg-white" : "bg-gray-50"}
                `}
              >

                {/* =================================================
                    PO ROW
                ================================================== */}
                <div
                  className={`
                    px-5
                    py-3.5
                    transition
                    ${
                      isExpanded
                        ? "bg-blue-50/40"
                        : index % 2 === 0
                          ? "bg-white hover:bg-gray-50"
                          : "bg-gray-50 hover:bg-gray-100"
                    }
                  `}
                >

                  <div className="flex items-center gap-3">

                    {/* =================================================
                        PO ICON
                    ================================================== */}
                    <div
                      className="
                        hidden
                        sm:flex
                        w-9
                        h-9
                        rounded-lg
                        bg-white
                        border
                        border-gray-200
                        items-center
                        justify-center
                        flex-shrink-0
                        shadow-sm
                      "
                    >
                      <FontAwesomeIcon
                        icon={faBox}
                        className="text-gray-400 text-xs"
                      />
                    </div>


                    {/* =================================================
                        PO NUMBER
                    ================================================== */}
                    <div className="w-[150px] min-w-0">

                      <p className="text-[10px] font-semibold text-gray-400 uppercase tracking-wider">
                        PO Number
                      </p>

                      <p className="text-sm font-semibold text-gray-900 truncate mt-0.5">
                        {subOrder.po_number ||
                          subOrder.readable_sub_order_number ||
                          "—"}
                      </p>

                      {subOrder.readable_sub_order_number &&
                        subOrder.po_number && (
                          <p className="text-[10px] text-gray-400 truncate">
                            {subOrder.readable_sub_order_number}
                          </p>
                        )}

                    </div>


                    {/* =================================================
                        SUPPLIER
                    ================================================== */}
                    <div className="flex-1 min-w-0">

                      <p className="text-[10px] font-semibold text-gray-400 uppercase tracking-wider">
                        Supplier
                      </p>

                      <p className="text-sm font-semibold text-gray-900 truncate mt-0.5">
                        {subOrder.vendor_id?.company_name ||
                          subOrder.vendor_id?.name ||
                          "—"}
                      </p>

                      {subOrder.vendor_id?.mobile_number && (
                        <p className="text-xs text-gray-500 truncate">
                          {subOrder.vendor_id.mobile_number}
                        </p>
                      )}

                    </div>


                    {/* =================================================
                        STATUS - MOVED NEXT TO SUPPLIER
                    ================================================== */}
                    <div className="hidden md:flex items-center gap-2 flex-shrink-0">

                      <span className="text-[10px] font-semibold text-gray-400 uppercase tracking-wider">
                        Status
                      </span>

                      <span
                        className="
                          inline-flex
                          items-center
                          px-2.5
                          py-1
                          rounded-full
                          text-[10px]
                          font-semibold
                          bg-blue-50
                          text-blue-700
                          border
                          border-blue-100
                          whitespace-nowrap
                        "
                      >
                        {subOrder.status || "—"}
                      </span>

                    </div>


                    {/* =================================================
                        BILL
                    ================================================== */}
                    <div className="flex-shrink-0">

                      {subOrder.billing_status === "Billed" ? (

                        <button
                          onClick={() => handleViewBill(subOrder)}
                          className="
                            inline-flex
                            items-center
                            gap-1.5
                            px-2.5
                            py-1.5
                            rounded-md
                            border
                            border-green-200
                            bg-green-50
                            text-green-700
                            text-xs
                            font-semibold
                            hover:bg-green-100
                            transition
                            whitespace-nowrap
                          "
                        >

                          <Eye size={13} />

                          <span className="hidden sm:inline">
                            View Bill
                          </span>

                          <span className="sm:hidden">
                            Bill
                          </span>

                        </button>

                      ) : (

                        <span className="text-xs text-gray-400">
                          —
                        </span>

                      )}

                    </div>


                    {/* =================================================
                        INVOICE
                    ================================================== */}
                    <div className="flex-shrink-0">

                      {subOrder.invoice_number ? (

                        <button
                          onClick={() => handleViewInvoice(subOrder)}
                          title={`View Invoice ${subOrder.invoice_number}`}
                          className="
                            inline-flex
                            items-center
                            gap-1.5
                            px-2.5
                            py-1.5
                            rounded-md
                            border
                            border-blue-200
                            bg-blue-50
                            text-blue-600
                            text-xs
                            font-semibold
                            hover:bg-blue-100
                            transition
                            whitespace-nowrap
                          "
                        >

                          <Eye size={13} />

                          <span className="hidden sm:inline">
                            Invoice
                          </span>

                          <span className="sm:hidden">
                            View
                          </span>

                        </button>

                      ) : (

                        <span className="text-xs text-gray-400">
                          —
                        </span>

                      )}

                    </div>


                    {/* =================================================
                        CHEVRON - FAR RIGHT
                    ================================================== */}
                    <button
                      type="button"
                      onClick={() =>
                        setExpandedPO(
                          isExpanded
                            ? null
                            : subOrder._id
                        )
                      }
                      className="
                        w-8
                        h-8
                        flex
                        items-center
                        justify-center
                        rounded-md
                        border
                        border-gray-200
                        bg-white
                        text-gray-500
                        hover:text-gray-700
                        hover:bg-gray-100
                        transition
                        flex-shrink-0
                      "
                      title={isExpanded ? "Collapse" : "Expand"}
                    >

                      <ChevronDown
                        size={16}
                        className={`
                          transition-transform
                          duration-200
                          ${
                            isExpanded
                              ? "rotate-180"
                              : ""
                          }
                        `}
                      />

                    </button>

                  </div>


                  {/* =================================================
                      MOBILE STATUS
                  ================================================== */}
                  <div className="md:hidden mt-2 flex items-center gap-2">

                    <span className="text-[10px] text-gray-400 uppercase tracking-wide">
                      Status
                    </span>

                    <span
                      className="
                        px-2
                        py-0.5
                        rounded-full
                        text-[10px]
                        font-semibold
                        bg-blue-50
                        text-blue-700
                        border
                        border-blue-100
                      "
                    >
                      {subOrder.status || "—"}
                    </span>

                  </div>

                </div>


                {/* =================================================
                    EXPANDED PO CONTENT
                ================================================== */}
                {isExpanded && (

                  <div
                    className="
                      px-5
                      pb-4
                      bg-blue-50/40
                      border-t
                      border-blue-100
                    "
                  >

                    <div className="pt-4">

                      <div
                        className="
                          grid
                          grid-cols-1
                          md:grid-cols-[120px_minmax(0,1fr)]
                          gap-5
                        "
                      >

                        {/* =================================================
                            IMAGE
                        ================================================== */}
                        <div>

                          {subOrder.po_images &&
                          subOrder.po_images.length > 0 ? (

                            <img
                              src={`${imageurl}${subOrder.po_images[0]}`}
                              alt="PO"
                              onClick={() => {
                                setShowPreview(true);
                                setSubOrderData(subOrder);
                              }}
                              className="
                                w-28
                                h-28
                                object-cover
                                rounded-lg
                                cursor-pointer
                                border
                                border-gray-200
                                hover:opacity-80
                                transition
                                shadow-sm
                              "
                            />

                          ) : (

                            <div
                              className="
                                w-28
                                h-28
                                rounded-lg
                                border
                                border-dashed
                                border-gray-300
                                bg-white
                                flex
                                items-center
                                justify-center
                                text-xs
                                text-gray-400
                              "
                            >
                              No Image
                            </div>

                          )}

                        </div>


                        {/* =================================================
                            ITEMS
                        ================================================== */}
                        <div className="min-w-0">

                          <div className="flex items-center justify-between mb-2">

                            <p
                              className="
                                text-[10px]
                                font-semibold
                                text-gray-400
                                uppercase
                                tracking-wider
                              "
                            >
                              Order Items
                            </p>

                            <span className="text-[10px] text-gray-400">
                              {subOrder.items?.length || 0} Items
                            </span>

                          </div>


                          <div
                            className="
                              border
                              border-gray-200
                              rounded-lg
                              overflow-hidden
                              bg-white
                              shadow-sm
                            "
                          >

                            <div className="max-h-48 overflow-y-auto custom-scrollbar">

                              <table className="w-full text-sm">

                                <thead className="bg-gray-50 sticky top-0">

                                  <tr>

                                    <th
                                      className="
                                        px-3
                                        py-2.5
                                        text-left
                                        text-[10px]
                                        font-semibold
                                        text-gray-500
                                        uppercase
                                      "
                                    >
                                      Item
                                    </th>

                                    <th
                                      className="
                                        px-3
                                        py-2.5
                                        text-right
                                        text-[10px]
                                        font-semibold
                                        text-gray-500
                                        uppercase
                                      "
                                    >
                                      Quantity
                                    </th>

                                  </tr>

                                </thead>

                                <tbody className="divide-y divide-gray-100">

                                  {subOrder.items?.length > 0 ? (

                                    subOrder.items.map((item) => (

                                      <tr
                                        key={item._id}
                                        className="hover:bg-gray-50"
                                      >

                                        <td className="px-3 py-2.5 text-sm text-gray-900">
                                          {item.item_name}
                                        </td>

                                        <td
                                          className="
                                            px-3
                                            py-2.5
                                            text-right
                                            text-sm
                                            font-semibold
                                            text-gray-900
                                          "
                                        >
                                          {item.quantity}
                                        </td>

                                      </tr>

                                    ))

                                  ) : (

                                    <tr>

                                      <td
                                        colSpan={2}
                                        className="
                                          px-3
                                          py-5
                                          text-center
                                          text-xs
                                          text-gray-400
                                        "
                                      >
                                        No items found
                                      </td>

                                    </tr>

                                  )}

                                </tbody>

                              </table>

                            </div>

                          </div>

                        </div>

                      </div>


                      {/* =================================================
                          EXPANDED FOOTER
                      ================================================== */}
                      <div
                        className="
                          flex
                          flex-wrap
                          items-center
                          gap-x-6
                          gap-y-2
                          mt-4
                          pt-3
                          border-t
                          border-blue-100
                        "
                      >

                        <div className="text-xs">

                          <span className="text-gray-400">
                            Billing Status
                          </span>

                          <span className="ml-2 font-semibold text-gray-700">
                            {subOrder.billing_status || "—"}
                          </span>

                        </div>


                        <div className="text-xs">

                          <span className="text-gray-400">
                            Invoice
                          </span>

                          <span className="ml-2 font-semibold text-gray-700">
                            {subOrder.invoice_number || "—"}
                          </span>

                        </div>

                      </div>

                    </div>

                  </div>

                )}

              </div>
            );
          })}

          </div>

        ) : (

          <div className="
            min-h-[300px]
            flex
            flex-col
            items-center
            justify-center
            text-center
            p-10
          ">

            <div className="
              w-12
              h-12
              rounded-full
              bg-gray-50
              border
              border-gray-200
              flex
              items-center
              justify-center
              mb-3
            ">

              <FontAwesomeIcon
                icon={faBoxesStacked}
                className="text-gray-300 text-lg"
              />

            </div>

            <p className="text-sm font-semibold text-gray-500">
              No Purchase Orders
            </p>

            <p className="text-xs text-gray-400 mt-1">
              There are no purchase orders for this delivery group.
            </p>

          </div>

        )}

      </div>

    </div>

  </div>

</div>



      {showSlotPopup && (
  <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex justify-center items-center z-50 p-4">
    <div className="bg-white min-h-[50vh] p-6 rounded-lg w-100 shadow-xl flex flex-col">

      <h3 className="text-lg font-semibold mb-4">Change Delivery Slot</h3>

      {/* DATE INPUT */}
      <div className="mb-4">
        <label className="text-sm font-medium">Select Date</label>
        <input
          type="date"
          value={slotDate}
          onChange={(e) => setSlotDate(e.target.value)}
          className="w-full border px-3 py-2 rounded-md mt-1"
        />
      </div>

      {/* SLOT DROPDOWN */}
      <div className="mb-4">
        <label className="text-sm font-medium">Delivery Slot</label>
        <select
          value={slotTime}
          onChange={(e) => setSlotTime(e.target.value)}
          className="w-full border px-3 py-2 rounded-md mt-1"
        >
          <option value="">Select Slot</option>
          <option value="2:00 PM – 7:00 PM">2:00 PM – 7:00 PM</option>
          <option value="9:30 AM – 1:00 PM">9:30 AM – 1:00 PM</option>
        </select>
      </div>

      {/* FILL SPACE */}
      <div className="flex-grow" />

      {/* BUTTONS */}
      <div className="flex justify-end gap-4">
        <button
          onClick={closeSlotPopup}
          className="px-3 py-1 bg-gray-300 rounded-md"
        >
          Cancel
        </button>

        <button
          onClick={saveSlotUpdate}
          className="px-3 py-1 bg-red-500 text-white rounded-md"
        >
          Save
        </button>
      </div>

    </div>
  </div>
)}

   {shiftPopupVisible && (
  <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
    <div className="bg-white w-[90%] max-w-sm rounded-lg p-6 shadow-lg min-h-[400px] flex flex-col justify-between">
      
      <div>
        <h3 className="text-lg font-bold text-gray-800 mb-6">Update Shift</h3>

        {/* BILL TO */}
        <div className="mb-6">
          <p className="font-semibold text-gray-700 mb-2">Bill To</p>
          <p className="bg-gray-100 p-3 rounded text-gray-800">Brickbucket</p>
        </div>

        {/* SHIFT TO */}
        <div className="mb-6">
          <p className="font-semibold text-gray-700 mb-2">Ship To</p>
          <select
            value={shiftToValue}
            onChange={(e) => setShiftToValue(e.target.value)}
            className="w-full border rounded p-2"
          >
            <option value="Brickbucket">Brickbucket</option>
            <option value="Customer">Customer</option>
          </select>
        </div>
      </div>

      {/* BUTTONS */}
      <div className="flex justify-end gap-6 border-t border-gray-200 pt-4 mt-4">
  <button
    className="px-3 py-1 bg-gray-300 rounded hover:bg-gray-400 transition"
    onClick={() => setShiftPopupVisible(false)}
  >
    Cancel
  </button>

  <button
    className="px-3 py-1 bg-blue-600 text-white rounded hover:bg-blue-700 transition"
    onClick={saveShiftChange}
  >
    Save
  </button>
</div>

    </div>
  </div>
)}


{billPopup && billData && (
  <div className="fixed inset-0 bg-black/40 flex justify-center items-center z-50 p-4">
    <div className="bg-white w-full max-w-lg rounded-xl p-6 shadow-2xl">

      {/* HEADER */}
      <div className="flex justify-between items-center mb-5">
        <h2 className="text-xl font-semibold text-gray-800">Bill Details</h2>
        <button
          onClick={() => {
            setBillPopup(false);
            setEditBill(false); // reset edit state so next open shows pencil
          }}
        >
          <X size={24} className="text-gray-500 hover:text-gray-700" />
        </button>
      </div>

      {/* BILL NUMBER row: label + bill no + pencil on same line */}
      <div className="mb-5">
        <label className="text-sm font-medium text-gray-700 block mb-2">Bill Number</label>

        <div className="flex items-center gap-3">
          {/* bill number input (disabled unless editing) */}
          <input
            type="text"
            value={billNumber}
            disabled={!editBill}
            onChange={(e) => setBillNumber(e.target.value)}
            className={`flex-1 px-3 py-2 border rounded-lg ${
              editBill ? "bg-white border-blue-500 text-gray-900" : "bg-gray-100 text-gray-600 cursor-not-allowed border-gray-200"
            }`}
          />


          {/* Pencil edit icon (FontAwesome) - always visible when popup opens */}
        {!editBill && (
  <button
    onClick={() => setEditBill(true)}
    className="text-blue-600 hover:text-blue-800 p-2 rounded"
    title="Edit bill number"
  >
    <FontAwesomeIcon icon={faPencilAlt} />
  </button>
)}
        </div>
      </div>

      {/* FILES SECTION */}
      <div>
        <p className="font-medium mb-3 text-gray-800">Files</p>

        {(!billData.files || billData.files.length === 0) ? (
          <p className="text-gray-500 text-sm">No files uploaded</p>
        ) : (
          <div className="space-y-3">
            {billData.files.map((file, idx) => {
              // file may be a path like "uploads/abc.pdf" or full url; handle both
              const fname = file.split("/").pop();
              const isPDF = fname.toLowerCase().endsWith(".pdf");
              return (
                <div
                  key={idx}
                  className="border p-3 rounded-lg flex items-center justify-between bg-gray-50"
                >
                  <div className="flex items-center gap-3">
                    {/* PDF icon or image preview */}
                    {isPDF ? (
                      <div className="w-10 h-10 flex items-center justify-center rounded bg-red-50">
                        <FontAwesomeIcon icon={faFilePdf} className="text-red-600" />
                      </div>
                    ) : (
                      <img
                        src={imageurl + file}
                        alt={fname}
                        className="w-14 h-14 object-cover rounded"
                        onError={(e) => { e.currentTarget.style.display = 'none'; }}
                      />
                    )}

                    {/* truncated filename */}
                    <div className="flex flex-col">
                      <span className="text-sm font-medium text-gray-800">{truncateFileName(fname, 34)}</span>
                      <span className="text-xs text-gray-500">{isPDF ? "PDF" : "Image"}</span>
                    </div>
                  </div>

                  {/* view link */}
                  <a
                    href={imageurl + file}
                    target="_blank"
                    rel="noreferrer"
                    className="text-blue-600 text-sm underline ml-4"
                  >
                    View
                  </a>
                </div>
              );
            })}
          </div>
        )}
      </div>
      {!editBill && !billData.bill_accepted && billData.reject_reason && (
  <div className="mb-4 p-3 bg-gray-50 border border-gray-200 rounded-xl mt-4">
    <div className="flex items-start gap-2">
      <div>
        <h4 className="font-semibold text-orange-800 mb-1">Bill Rejected</h4>
        <p className="text-sm leading-relaxed">
          {billData.reject_reason}
        </p>
       
      </div>
    </div>
  </div>
)}

{((showRejectReason && !billData?.reject_reason?.trim()) || editBill) &&
  !billData.bill_accepted && (

          <div className="mb-6 p-2 mt-2 bg-gray-50 border border-gray-200 rounded-lg">
          <label className="block text-sm font-semibold text-red-800 mb-2">
            Rejection Reason <span className="">*</span>
          </label>
          <textarea
            value={rejectReason}
            onChange={(e) => setRejectReason(e.target.value)}
            placeholder="Enter reason for rejection (e.g., Wrong amount, Missing items...)"
            rows={3}
            className="w-full border border-gray-300 rounded-lg p-3   focus:border-gray-200 "
            maxLength={500}
          />
        
        </div>
      )}

      {/* BUTTONS */}
<div className="flex justify-end gap-4 mt-6">
  {!editBill && !billData.bill_accepted && (
    <>
      {/* If reject reason already exists, show Accept + Reject again */}
      {billData?.reject_reason ? (
        <div className="flex gap-4">
          <button
            onClick={() => {
              setRejectReason("");
              setShowRejectReason(true);
            }}
            className="px-6 py-2 bg-red-50 hover:bg-red-100 text-red-700 font-semibold border-2 border-red-200 hover:border-red-300 rounded-lg flex items-center gap-2 transition-all"
          >
            <FontAwesomeIcon icon={faTimes} />
            Reject
          </button>

          <button
            onClick={handleAcceptBill}
            className="px-6 py-2 bg-green-50 hover:bg-green-100 text-green-700 font-semibold border-2 border-green-200 hover:border-green-300 rounded-lg flex items-center gap-2 transition-all"
          >
            <FontAwesomeIcon icon={faCheck} />
            Accept
          </button>
        </div>
      ) : showRejectReason ? (
        <button
          onClick={() => handleRejectBill(rejectReason)}
          disabled={!rejectReason.trim()}
          className={`px-4 py-1 font-semibold border-2 rounded-lg flex items-center gap-2 ${
            !rejectReason.trim()
              ? "bg-gray-100 text-gray-400 border-gray-200 cursor-not-allowed"
              : "bg-red-600 text-white hover:bg-red-700 border-red-600 shadow-sm"
          }`}
        >
          Save
        </button>
      ) : (
        <div className="flex gap-4">
          <button
            onClick={() => setShowRejectReason(true)}
            className="px-6 py-2 bg-red-50 hover:bg-red-100 text-red-700 font-semibold border-2 border-red-200 hover:border-red-300 rounded-lg flex items-center gap-2 transition-all"
          >
            <FontAwesomeIcon icon={faTimes} />
            Reject
          </button>

          <button
            onClick={handleAcceptBill}
            className="px-6 py-2 bg-green-50 hover:bg-green-100 text-green-700 font-semibold border-2 border-green-200 hover:border-green-300 rounded-lg flex items-center gap-2 transition-all"
          >
            <FontAwesomeIcon icon={faCheck} />
            Accept
          </button>
        </div>
      )}
    </>
  )}

  {editBill && (
    <>
      <button
        onClick={() => {
          setBillPopup(false);
          setEditBill(false);
        }}
        className="px-4 py-2 bg-gray-200 hover:bg-gray-300 rounded-lg"
      >
        Cancel
      </button>

      <button
        onClick={updateBillNumber}
        className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg"
      >
        Update
      </button>
    </>
  )}
</div>

    </div>
  </div>
)}

 {/* IMAGE PREVIEW MODAL */}
{showPreview && (
  <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-2">
    <div className="bg-white rounded-xl p-1 w-full max-w-4xl relative shadow-xl">

      {/* Close Button */}
      <button
        onClick={() => setShowPreview(false)}
        className="absolute top-2 right-3 text-gray-700 text-xl font-bold hover:text-black"
      >
        ✕
      </button>

      {/* Title */}
      <h2 className="text-lg font-semibold text-gray-800 mb-4 text-center">
       Images
      </h2>

      {/* Image Container */}
      <div
        className={`flex ${
          subOrderData.po_images.length > 1 ? "overflow-x-auto gap-6" : "justify-center"
        } py-4`}
        style={{ scrollSnapType: "x mandatory" }}
      >
        {subOrderData.po_images.map((img, idx) => (
          <div
            key={idx}
            className="min-w-[300px] max-w-[300px] scroll-snap-align-start flex justify-center"
          >
            <img
              src={imageurl + img}
              className="max-h-[450px] rounded-lg object-contain border shadow-md"
              alt="PO Full View"
            />
          </div>
        ))}
      </div>


     
    </div>
  </div>
)}

{/* Success and small toasts */}
{/* {showPopup && popupType === '200or201' && (
  <div className="fixed top-4 right-4 z-[999] pointer-events-none">
    <div className="pointer-events-auto">
      <Msg200or201 message={popupMessage} timeout={1000} />
    </div>
  </div>
)} */}

{/* {showPopup && (
  <div className="z-[999]">
    {popupType === '200or201' && <Msg200or201 message={popupMessage} timeout={3000} />}
    {popupType === '204' && <Msg204 message={popupMessage} timeout={3000} />}
    {popupType === '400' && <Msg400 message={popupMessage} closePopup={closePopup} />}
    {popupType === '409' && <Msg409 message={popupMessage} closePopup={closePopup} />}
          {popupType === '401' && <Msg401 message={popupMessage} closePopup={BackToLoginPage} />}
          {popupType === '403' && <Msg403 message={popupMessage} closePopup={BackToLoginPage} />}
          {popupType === '500' && <Msg500 message={popupMessage} closePopup={Retry} cancelPopup={closePopup} />}
  </div>
)} */}

    </div>
  );
 
};
export default RenderDeliveryGroupMapping